import server from "@/api/server";

async function invitePartner(userObj) {
  let res = await server.post("/agent/agent/subpartner/invite", userObj);
  return res;
}

export { invitePartner };
